import { useModuleEnabled } from "redux/selectors/modules";
import { setOverrideModule, unsetOverrideModule } from "redux/reducers/overrideModulesReducer";
import { useAppSelector } from "redux/hooks";
import store from "redux/store";
import { Flex } from "../../../styled-system/jsx";
import { css } from "../../../styled-system/css";
import { useHistory, useParams } from "react-router-dom";

interface Params {
  id?: string;
}

const DashboardSelector = () => {
  const hasOldDashboardModule = useModuleEnabled("ADS_V1");
  const user = useAppSelector((state) => state.user);
  const { id: categoryId } = useParams<Params>();
  const history = useHistory();

  return (
    <Flex
      className={css({
        border: "1px solid #c0c0c0",
        width: "100%",
        margin: 0,
        padding: "medium",
        color: "#fff",
        fontSize: "small",
        backgroundColor: "#9D7EB8",
      })}
      gap={"medium"}
      justifyContent={"center"}
    >
      {hasOldDashboardModule ?
        <>
          Try out the new Advertising dashboard!{" "}
          <span
            className={css({ cursor: "pointer", color: "#fff", textDecoration: "underline" })}
            onClick={() => {
              store.dispatch(unsetOverrideModule({ orgId: user.organization_id, module: "ADS_V1" }));
            }}
          >
            View the new dashboard
          </span>
        </>
      : <>
          Revert to the old Advertising dashboard{" "}
          <span
            className={css({ cursor: "pointer", color: "#fff", textDecoration: "underline" })}
            onClick={() => {
              store.dispatch(setOverrideModule({ orgId: user.organization_id, module: "ADS_V1" }));
              if (categoryId) {
                return void history.push(`/user/advertising/dashboard/category/${categoryId}`);
              } else {
                return void history.push(`/user/advertising/dashboard`);
              }
            }}
          >
            View the original dashboard
          </span>
        </>
      }
    </Flex>
  );
};

export default DashboardSelector;
